import {useTranslation} from "react-i18next";
import { STATUS_CREATED, STATUS_IN_PROGRESS, STATUS_NOT_FOUND, STATUS_FOUND, STATUS_UNDER_SEIZURE,
    STATUS_RELEASE, STATUS_RECOVERED
} from "../../finessecurity/component/Constants";
import {useTheme} from "@mui/material";


export const useStatusValues = () => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const theme = useTheme();
    const getStatusColor = (status: number) => {
        switch (status) {
            case STATUS_CREATED: return theme.palette.warning.transparent;
            case STATUS_IN_PROGRESS: return theme.palette.secondary.transparent;
            case STATUS_NOT_FOUND: return theme.palette.error.transparent;
            case STATUS_FOUND: return theme.palette.accent.transparent;
            case STATUS_UNDER_SEIZURE: return theme.palette.info.transparent;
            case STATUS_RELEASE: return theme.palette.accent.light;
            case STATUS_RECOVERED: return theme.palette.success.transparent;
        }
    };
    const getStatusValues = (status: number) => {
            switch (status) {
                case STATUS_CREATED: return t('eventInfo.created');
                case STATUS_IN_PROGRESS: return t('eventInfo.inProgress');
                case STATUS_NOT_FOUND: return t('eventInfo.notFound');
                case STATUS_FOUND: return t('eventInfo.found');
                case STATUS_UNDER_SEIZURE: return t('eventInfo.underSeizure');
                case STATUS_RELEASE: return t('eventInfo.release');
                case STATUS_RECOVERED: return t('eventInfo.recovered');

                default : return '-'
            }
    };


    return {
        getStatusValues, getStatusColor
    }
}